import { buildSchema } from "@camberi/firecms";

const companySchema = buildSchema({
    name: "companies",
    properties: {
        name: {
            dataType: "string",
            title: "name",
            // disabled: true,
            validation: {
                required: true,
            }
        },

        address: {
            dataType: "string",
            title: "Address",
            // disabled: true,
            validation: {
                required: true,
            }
        },

        start_date:{
            dataType:"timestamp",
            title:"Start Date",
            validation:{
                required:true,
            }
        },

        end_date:{
            dataType:"timestamp",
            title:"End Date",
            validation:{
                required:true,
            }
        },

        users: {
            dataType: "array",
            title: "User Emails",
            // disabled: true,
            validation: {
                required: true,
            },
            of:{
                dataType: "string",
            }

            
        },

        created_at: {
            dataType: "timestamp",
            title: "Created Date Time",
            disabled: true,
            autoValue: "on_create"
        },
        updated_at: {
            dataType: "timestamp",
            title: "Updated  Date Time",
            disabled: true,
            autoValue: "on_update"
        }
    }
});

companySchema.onSaveSuccess = () => {
    console.log("onSaveSuccess");
};

export default companySchema;
